import { Box, dimensions, zIndex } from '@factorialco/deprecated-design-system'

import Portal from 'modules/core/components/Portal'

import FileViewer from 'modules/documents/components/FileViewer'
import type { Props as FileViewerProps } from 'modules/documents/components/FileViewer'

export enum ViewType {
  DEFAULT = 'default',
  INVOICE_DETAIL = 'invoiceDetail',
}

const widths = {
  [ViewType.DEFAULT]: '432px',
  [ViewType.INVOICE_DETAIL]: '550px',
}

interface Props {
  onClose: () => void
  fileViewerProps?: FileViewerProps
  beforeFileViewer?: React.ReactElement
  content?: React.ReactElement
  type?: ViewType
}

const DocumentViewer = ({
  onClose,
  fileViewerProps,
  beforeFileViewer,
  content,
  type = ViewType.DEFAULT,
}: Props) => {
  return (
    <Portal onClose={onClose}>
      <Box
        width="full"
        height="full"
        background="grey000White"
        overflowX="auto"
        overflowY="auto"
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          zIndex: zIndex.modals,
        }}
      >
        <Box
          flexDirection="row"
          width="full"
          height="full"
          style={{ flex: '1 1 auto', minWidth: dimensions.narrowPage }}
        >
          <Box overflowX="auto" background="grey200" flexGrow>
            {beforeFileViewer}
            <Box flexGrow alignItems="center" justifyContent="center">
              {fileViewerProps && <FileViewer {...fileViewerProps} />}
            </Box>
          </Box>
          <Box flexNoShrink style={{ width: widths[type] }}>
            {content}
          </Box>
        </Box>
      </Box>
    </Portal>
  )
}

export default DocumentViewer
